// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__sNsXW","loaderSpinner":"Loader_loaderSpinner__H1Q6J","spin":"Loader_spin__xKLrU"};